import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { humanCase } from '@paragon/utilities';

import { finishInsertingFeatureArea } from '../../../../store/actions/layout/featureAreaActions';
import {
  isInsertionFeatureAreaFullyDefined,
  switchInsertionFeatureAreaType,
  updateInsertionFeatureArea,
  updateInsertionFeatureAreaContainerGuid,
} from '../../../../store/slices/applicationSlice';
import { FeaturePatternContainerSelect } from '../../../controls/FeaturePatternContainerSelect';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { FeatureAreaTypeSelect } from '../elements/FeatureAreaTypeSelect';
import { FeatureAreaRectangleControls } from '../properties/layout-feature-areas/comon/FeatureAreaRectangleControls';
import { FeatureAreaUniquePropertyControls } from '../properties/layout-feature-areas/FeatureAreaUniquePropertyControls';
import InsertionPanelContainer from './InsertionPanelContainer';

export function FeatureAreaInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  if (insertingObjectInfo?.type !== 'featureArea') return null;

  const insertionFeatureArea = insertingObjectInfo.data.value;

  const readyToInsert = isInsertionFeatureAreaFullyDefined(insertionFeatureArea);

  return (
    <InsertionPanelContainer
      disabled={!readyToInsert}
      onInsert={() => {
        dispatch(finishInsertingFeatureArea());
      }}
    >
      <Box sx={{ p: 1, mb: 2 }} className="clickable-during-picking">
        <Typography align="center" variant="h5" sx={{ marginBottom: 3 }}>
          {humanCase(insertionFeatureArea.featureType)} Creation
        </Typography>

        <Stack spacing={2} sx={{ marginBottom: 2 }}>
          <Stack direction="row" spacing={2}>
            <FeatureAreaTypeSelect
              value={insertionFeatureArea.featureType}
              onChange={(type) => void dispatch(switchInsertionFeatureAreaType(type))}
            />

            <FeaturePatternContainerSelect
              featurePatternContainerGuid={insertingObjectInfo.data.featurePatternContainerGuid}
              onChange={(featurePatternContainerGuid) => {
                dispatch(updateInsertionFeatureAreaContainerGuid(featurePatternContainerGuid));
              }}
            />
          </Stack>

          <Divider />

          <FeatureAreaRectangleControls
            value={insertionFeatureArea}
            onChange={(editedArea) => {
              dispatch(updateInsertionFeatureArea(editedArea));
            }}
          />

          <Divider />

          <FeatureAreaUniquePropertyControls
            value={insertionFeatureArea}
            onChange={(editedArea) => {
              dispatch(updateInsertionFeatureArea(editedArea));
            }}
          />
        </Stack>
      </Box>
    </InsertionPanelContainer>
  );
}
